import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Pagination, Select, Image } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Option } from "antd/es/mentions";
import AWS from "aws-sdk";
import moment from "moment";

import { PaperClipOutlined, CloseCircleOutlined } from "@ant-design/icons";

import csCenterApi from "../../../apis/CsCenter.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { plutusS3 } from "../../../utils/plutusS3";

const CsCenterInquiryComponent = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [inquiryEndType, setInquiryEndType] = useState(false);
  const [inquiryType, setInquiryType] = useState("total");
  const [dateType, setDateType] = useState("desc");
  const [offset, setOffset] = useState(0);
  const [totalSize, setTotalSize] = useState(1);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [inquiryAnswer, setInquiryAnswer] = useState("");
  const [inquiryAnswerValidation, setInquiryAnswerValidation] = useState(false);
  const [imagePreviews, setImagePreviews] = useState([]);

  const [csInquiryList, setCsInquiryList] = useState([]);
  const [currentInquiry, setCurrentInquiry] = useState({});

  const inquiryItems = [
    { inquiryType: "total", inquiryText: "전체 문의" },
    { inquiryType: "general", inquiryText: "일반 문의" },
    { inquiryType: "alliance", inquiryText: "제휴 문의" },
    { inquiryType: "ad", inquiryText: "광고 문의" },
    { inquiryType: "investment", inquiryText: "투자 문의" },
    { inquiryType: "etc", inquiryText: "기타 문의" },
  ];
  const dateItems = [
    { dateType: "desc", dateText: "최신순" },
    { dateType: "asc", dateText: "오래된순" },
  ];
  const pageSize = 15;

  useEffect(() => {
    getReadCsCenterInquiryList(props.location.state);
  }, [inquiryEndType, inquiryType, dateType, offset]);

  /**
   * 답변목록 가져오기
   * @param {*} offset
   * @param {*} PageSize
   * @param {*} searchType
   * @param {*} searchText
   * @param {*} answerStatusFilter
   * @param {*} sortFilter
   */
  const getReadCsCenterInquiryList = async (selectInquiry = null) => {
    setIsLoading(true);
    try {
      const res = await csCenterApi.getReadCsCenterInquiryList(
        offset,
        pageSize,
        inquiryEndType,
        inquiryType,
        dateType,
        true,
      );
      if (res.code === 200) {
        if (selectInquiry) {
          const findInquiryIdx = res.result.csInquiryList.findIndex(
            (inquiry) => inquiry.id === selectInquiry,
          );
          if (findInquiryIdx !== -1) {
            setCurrentInquiry(res.result.csInquiryList[findInquiryIdx]);
          } else {
            setCurrentInquiry(res.result.csInquiryList[0]);
          }
          history.replace({ state: null });
        } else if (res.result.csInquiryList?.length > 0) {
          setCurrentInquiry(res.result.csInquiryList[0]);
        } else {
          setCurrentInquiry({});
        }
        setCsInquiryList(res.result.csInquiryList);
        if (res.result.total !== 0) {
          setTotalSize(res.result.total);
        }
      } else {
        alert(
          "문의 목록을 조회하는데 실패하였습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      alert("정상적인 요청이 아닙니다.");
    }
  };

  /**
   * 대기중 <-> 답변완료
   * 대기중 : false, 답변완료 : true
   */
  const handleStatusChange = (result) => {
    setInquiryEndType(result);
    handleChangePage(1);
    setInquiryAnswer("");
    setInquiryAnswerValidation(false);
  };

  /**
   * handleChangePage
   */
  const handleChangePage = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  const handleSelectChange = (value, type) => {
    if (type === "inquiry") {
      setInquiryType(value);
    } else {
      setDateType(value);
    }
    handleChangePage(1);
  };

  /**
   * QA 텍스트 Change
   */
  const handleTextChange = (e) => {
    if (e.target.value !== "") {
      setInquiryAnswer(e.target.value);
      setInquiryAnswerValidation(true);
    } else {
      setInquiryAnswer("");
      setInquiryAnswerValidation(false);
    }
  };

  const handleImageSelect = (e) => {
    const files = e.target.files;
    if (files.length > 3) {
      window.alert("답변 이미지는 3장까지만 등록 가능합니다.");
    } else {
      const selectedFiles = Array.from(files).slice(0, 3);
      const previews = [];
      selectedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push({
            name: file.name,
            type: file.type.split("/")[1],
            status: "done",
            url: reader.result,
            originFileObj: file,
          });
          setImagePreviews([...previews]);
        };
        reader.readAsDataURL(file);
      });
    }
  };
  const fileInputRef = useRef(null);

  const handleImageSelectDelete = (index) => {
    const updatedImagePreviews = [...imagePreviews];
    updatedImagePreviews.splice(index, 1);
    setImagePreviews(updatedImagePreviews);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    setImagePreviews([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [currentInquiry]);

  /**
   * 문의 이미지 s3Upload올리기
   */
  const s3Upload = async (file, idx, type, id) => {
    // let fileType = file.type.split("/")[1]
    let currIdx = `${idx}`;
    let s3Path = `image/inquiry/chat/answer/${id}_${currIdx}.${type}`;

    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: file,
    };
    let res = await plutusS3.putObject(params).promise();

    return res.success === true;
  };
  /**
   * 문의 답변 제출하기
   * @returns {Promise<void>}
   */
  const submitInquiryAnswer = async () => {
    setIsLoading(true);

    let imageList = [];

    imagePreviews.forEach((img, idx) => {
      imageList.push({
        title: `${currentInquiry.id}_${idx + 1}`,
        img_type: img.type,
      });
    });

    let param = {
      user_id: user.user_id,
      csCenter: {
        id: currentInquiry.id,
        answer_content: inquiryAnswer,
      },
      answerImageList: imageList,
    };

    let res = await csCenterApi.postUpdateCsCenterInquiry(param);
    let rsp = await Promise.all(
      imagePreviews.map(async (img, idx) => {
        return await s3Upload(
          img.originFileObj,
          idx + 1,
          img.type,
          currentInquiry.id,
        );
      }),
    );
    if (res.code === 200 || !rsp.includes(false)) {
      setIsLoading(false);
      if (inquiryEndType) {
        window.alert("해당 문의사항에 대한 답변이 수정되었습니다");
      } else {
        window.alert("새로운 답변이 등록되었습니다");
      }
      // 초기화
      if (!inquiryEndType) {
        getReadCsCenterInquiryList();
      }
      setCurrentInquiry({});
      handleStatusChange(false);
      setInquiryType("total");
      setDateType("desc");
      setImagePreviews([]);
    } else if (res.code === 999) {
      setIsLoading(false);
      window.alert(res.msg);
    } else {
      setIsLoading(false);
      window.alert("오류가 발생했습니다. 관리자에게 문의하세요");
    }
  };

  return (
    <div className="contentPage" style={{ margin: 24 }}>
      <div className="cs-inquiry-list-wrap cs-consider-mobile">
        <div className="cs-inquiry-menu-wrap">
          <div className="cs-inquiry-menu-status-wrap">
            <div
              onClick={() => handleStatusChange(false)}
              className={
                inquiryEndType
                  ? "inquiry-main-menu-status-wait"
                  : "inquiry-main-menu-status-wait-active"
              }
            >
              <div className="inquiry-main-menu-status-wait-img">
                <img
                  src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/${
                    inquiryEndType ? "wait_icon" : "wait_icon_active"
                  }.png`}
                />
              </div>
              대기중
            </div>
            <div className="inquiry-main-menu-status-divider">|</div>
            <div
              onClick={() => handleStatusChange(true)}
              className={
                inquiryEndType
                  ? "inquiry-main-menu-status-end-active"
                  : "inquiry-main-menu-status-end"
              }
            >
              <div className="inquiry-main-menu-status-end-img">
                <img
                  src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/${
                    inquiryEndType ? "answer_icon_active" : "answer_icon"
                  }.png`}
                />
              </div>
              답변완료
            </div>
          </div>
          <div className="inquiry-main-menu-title-wrap">
            <Select
              className="inquiry-main-menu-sort"
              defaultValue={inquiryType}
              onChange={(value) => handleSelectChange(value, "inquiry")}
            >
              {inquiryItems.map((item, idx) => {
                return (
                  <Option value={item.inquiryType} key={`inquiry-item-${idx}`}>
                    {item.inquiryText}
                  </Option>
                );
              })}
            </Select>
            <Select
              className="inquiry-main-menu-order"
              defaultValue={dateType}
              onChange={(value) => handleSelectChange(value, "date")}
            >
              {dateItems.map((item, idx) => {
                return (
                  <Option value={item.dateType} key={`date-item-type-${idx}`}>
                    {item.dateText}
                  </Option>
                );
              })}
            </Select>
          </div>
          <div className="inquiry-main-menu-contents-wrap">
            {csInquiryList?.length > 0 && (
              <>
                {csInquiryList.map((item) => {
                  let splited = item.title.split(" ");
                  return (
                    <div
                      key={"waitInquiry_" + item.id}
                      onClick={() => setCurrentInquiry(item)}
                      className={
                        currentInquiry.hasOwnProperty("id") &&
                        currentInquiry.id === item.id
                          ? "inquiry-main-menu-content-wrap active"
                          : "inquiry-main-menu-content-wrap"
                      }
                    >
                      <div>
                        <div className="inquiry-main-menu-info">
                          {splited[0]} {splited[1]}
                        </div>
                        <div className="inquiry-main-menu-content">
                          {item.question_content}
                        </div>
                      </div>
                      <div className="inquiry-main-menu-date">{splited[2]}</div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="cs-inquiry-main-menu-pagination-wrap">
            <Pagination
              size="small"
              total={totalSize}
              simple
              pageSize={pageSize}
              onChange={handleChangePage}
              current={currentPageNumber}
              style={{ display: "flex" }}
            />
          </div>
        </div>
        <div className="cs-inquiry-content-wrap">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div className="inquiry-main-content-header-wrap">
              <div className="inquiry-main-content-info-wrap">
                {currentInquiry &&
                  Object.keys(currentInquiry)?.length !== 0 && (
                    <>
                      <div className="cs-inquiry-content-info-title">
                        {currentInquiry.title.split(" ")[0]}{" "}
                        {currentInquiry.title.split(" ")[1]}{" "}
                        {currentInquiry.title.split(" ")[3]}
                      </div>
                      {/*{currentInquiry.company_name && (*/}
                      {currentInquiry.company_contact && (
                        <div className="cs-inquiry-content-info-company">
                          {currentInquiry?.company_name}{" "}
                          {currentInquiry?.company_part} {currentInquiry?.name}
                          님 / {currentInquiry?.company_contact}
                        </div>
                      )}
                    </>
                  )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: "space-between",
                minHeight: "60vh",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div className="inquiry-main-content-chat-wrap">
                {currentInquiry &&
                  Object.keys(currentInquiry)?.length !== 0 && (
                    <div className="user-inquiry-text-wrap">
                      <pre className="user-inquiry-text">
                        {currentInquiry.question_content}
                      </pre>
                      <div className="inquiry-text-date">
                        {moment(currentInquiry.created_at).format(`YY-MM-DD`)}
                      </div>
                    </div>
                  )}
                {currentInquiry &&
                  currentInquiry.hasOwnProperty("answer_status") &&
                  currentInquiry.answer_status === 1 && (
                    <div
                      className="admin-inquiry-text-wrap"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        gap: "0.5rem",
                      }}
                    >
                      <div className="admin-inquiry-answer-wrap">
                        <div className="admin-inquiry-answer-image-wrap">
                          {currentInquiry.answerImageList?.map(
                            (image, index) => (
                              <Image
                                key={index}
                                style={{
                                  maxWidth: "150px",
                                  maxHeight: "150px",
                                  border: "solid 1px #ced4da",
                                }}
                                alt={`chat img`}
                                src={`${process.env.REACT_APP_S3_HOST}/image/inquiry/chat/answer/${image.title}.${image.img_type}`}
                              />
                            ),
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div className="inquiry-text-date">
                          {moment(currentInquiry.answer_updated_at).format(
                            `YY-MM-DD`,
                          )}
                        </div>
                        <div
                          className="admin-inquiry-text"
                          style={{ wordBreak: "break-all" }}
                        >
                          {currentInquiry.answer_content}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <div className="inquiry-main-content-answer-wrap">
                {imagePreviews.length !== 0 && (
                  <div className="inquiry-main-content-answer-images-wrap">
                    {imagePreviews.map((file, idx) => (
                      <div className="inquiry-main-content-answer-image-wrap">
                        <div
                          className="inquiry-main-content-answer-image-delete-btn"
                          onClick={() => handleImageSelectDelete(idx)}
                        >
                          <CloseCircleOutlined />
                        </div>
                        <div className="inquiry-answer-image-edit">
                          <Image
                            src={file.url}
                            alt="Selected"
                            className="inquiry-main-content-answer-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {!inquiryEndType && (
                  <div className="inquiry-main-content-answer-box-img">
                    {/* 파일 선택 input */}
                    <label htmlFor="image-upload">
                      <PaperClipOutlined
                        style={{
                          cursor: "pointer",
                          height: "14px",
                        }}
                      />
                    </label>
                    <input
                      id="image-upload"
                      ref={(ref) => (fileInputRef.current = ref)}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleImageSelect}
                      multiple
                      disabled={imagePreviews.length >= 3}
                    />
                    <span className="inquiry-main-content-answer-box-img-explain">
                      이미지는 최대 3장만 업로드 가능합니다.
                    </span>
                  </div>
                )}
                <div
                  className="inquiry-main-content-answer-text-wrap"
                  style={{
                    paddingTop: inquiryEndType ? "20px" : "0",
                  }}
                >
                  <div className="inquiry-main-content-answer-box">
                    <TextArea
                      onChange={handleTextChange}
                      allowClear
                      type="text"
                      placeholder={
                        inquiryEndType
                          ? "답변을 수정하세요."
                          : "답변을 입력하세요"
                      }
                      disabled={isLoading}
                      value={inquiryAnswer}
                    />
                  </div>
                  <div className="inquiry-main-content-action-wrap">
                    <div
                      onClick={() => {
                        if (inquiryAnswerValidation && !isLoading) {
                          submitInquiryAnswer();
                        }
                      }}
                      className={
                        inquiryAnswerValidation && !isLoading
                          ? "inquiry-main-content-action-active"
                          : "inquiry-main-content-action"
                      }
                    >
                      전송
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CsCenterInquiryComponent;
